import { createContext } from 'react'
import type { StandaloneFlightsState } from './standaloneFlightsStateReducer'
import { initialState } from './standaloneFlightsStateReducer'

const StandaloneFlightStateContext = createContext<StandaloneFlightsState>({ ...initialState })

export default StandaloneFlightStateContext
